import { useState } from "react";
import { faqs } from "@/mocks/faq";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer.replace(/<[^>]*>/g, ""),
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-600 leading-relaxed">
              关于「第一次」的疑问，这里有答案
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={faq.id}
                className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden transition-all duration-300"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  onClick={() => toggleFaq(index)}
                  aria-expanded={openIndex === index}
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4 leading-relaxed">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </div>
                </button>
                <div
                  className={`px-5 overflow-hidden transition-all duration-300 ${
                    openIndex === index ? "pb-5 max-h-96" : "max-h-0"
                  }`}
                >
                  <p
                    className="text-sm text-foreground-600 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  ></p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}